/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Realm_You_HintInputs */



/**
* | output |
* | --- |
* | "Only affects your own account." |
*
* @param {Settings_Realm_You_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const settings_realm_you_hint = /** @type {((inputs?: Settings_Realm_You_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Realm_You_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Betrifft nur dein eigenes Konto.")
	return /** @type {LocalizedString} */ ("Only affects your own account.")
});